import * as React from 'react'
import { Container } from '../Container'
import { GraySection } from '../GraySection'

import shieldSecurityIcon from '../../../public/img/icons/shield-security-icon-orange.png'
import walletIcon from '../../../public/img/icons/wallet-icon-orange.png'
import brakeIcon from '../../../public/img/icons/brake-icon-orange.png'
import smileyIcon from '../../../public/img/icons/smiley-icon-orange.png'

import Image from 'next/image'

const REASON_ICONS = [shieldSecurityIcon, walletIcon, brakeIcon, smileyIcon]

const defaultReasons = [
  { title: 'SAFETY', description: 'Protect yourself and your loved ones. Faulty brakes risk accidents and lives.' },
  { title: 'COST SAVINGS', description: 'Spot early wear with regular checks, saving costly future repairs.' },
  { title: 'PERFORMANCE', description: 'Good brakes mean better handling, even in emergencies.' },
  { title: 'PEACE OF MIND', description: "Drive confidently, knowing your brakes won't let you down." },
]

type Props = {
  title: string
  description: string
  reasons?: { title: string; description: string }[]
}

export const WhyInspectionSection: React.FC<Props> = ({ title, description, reasons: reasonsProp }) => {
  const reasons = reasonsProp ?? defaultReasons
  return (
    <GraySection className="xl:py-20 text-center">
      <Container className="max-w-screen-lg">
        <div>
          <h2 className="title text-2xl sm:text-3xl md:text-4xl">{title}</h2>
          <p className="description">{description}</p>
        </div>
        <div className="grid gap-4 md:grid-cols-2">
          {reasons.map((item, index) => (
            <WhyInspectionItem
              key={index}
              title={item.title}
              description={item.description}
              iconSource={REASON_ICONS[index]}
            />
          ))}
        </div>
      </Container>
    </GraySection>
  )
}

const WhyInspectionItem: React.FC<{
  title: string
  description: string
  iconSource?: any
}> = ({ title, description, iconSource }) => {
  return (
    <div className="py-6 bg-white flex flex-grow-1 flex-col text-left px-6" style={{ border: '1px solid #dddddd' }}>
      <div className="bg-[#F04F231A] w-[88px] h-[88px] flex flex-row rounded-full items-center justify-center">
        <Image src={iconSource} alt="shield security icon" />
      </div>
      <div className="mt-3">
        <h3 className="text-xl">{title}</h3>
        <p className="description text-base mb-0 pb-0">{description}</p>
      </div>
    </div>
  )
}
